
import { useState } from "react";
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldDescription from "./FieldDescription";
import FieldImage from "./FieldImage";
import FieldPrice from "./FieldPrice";
import FieldStart from "./FieldStart";
import FieldExpertise from "./FieldExpertise";
import FieldTitle from "./FieldTitle";
import DoctorMultiSelect from "../../../../components/DoctorMultiSelect";


export default function Form({ webinar, isDesktop }) {
	const navigate = useNavigate();
	const [title, setTitle] = useState(webinar.title);
	const [description, setDescription] = useState(webinar.description);
	const [price, setPrice] = useState(webinar.price);
	const [image, setImage] = useState(null);
	const initialStartDatetime = webinar.start_datetime
		? new DateObject({ date: new Date(webinar.start_datetime), calendar: persian })
		: new DateObject({ calendar: persian });
	const [startDatetime, setStartDatetime] = useState(initialStartDatetime);
	const [instructorIds, setInstructorIds] = useState(webinar.instructors || []);
	const [expertiseIds, setExpertiseIds] = useState([]);
	const initialDoctors = webinar.instructors_detail || [];
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handlePriceChange = (e) => {
		setPrice(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleStartDatetimeChange = (value) => {
		setStartDatetime(value);
	}

	const handleExpertiseChange = (ids) => {
		setExpertiseIds(ids);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.webinarEdit({
			token: LoginHelper.getToken(),
			webinar_id: webinar.id,
			title: title,
			description: description,
			price: price,
			image_file: image,
			start_datetime: startDatetime.toDate().toISOString(),
			expertise_ids: JSON.stringify(expertiseIds),
			...(LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN ? { instructor_ids: JSON.stringify(instructorIds) } : {}),
		}).then((res) => {
			setIsLoading(false);
			const webinarId = res.id;
			navigate('/webinar_detail/' + webinarId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ویرایش وبینار"
			subtitle="تغییرات را ذخیره کنید تا در صفحه وبینار اعمال شود."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="ذخیره تغییرات"
		>
			<EditorFieldSection title="اطلاعات اصلی" description="عنوان، توضیحات و قیمت وبینار">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldPrice price={price} onChange={handlePriceChange} />
			</EditorFieldSection>
			<EditorFieldSection title="زمان و تصویر" description="تاریخ شروع و تصویر کاور">
				<FieldStart startDatetime={startDatetime} onChange={handleStartDatetimeChange} />
				<FieldImage existingPreviewUrl={webinar.image} onChange={handleImageChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تخصص‌ها">
				<FieldExpertise
					webinar={webinar}
					onChange={handleExpertiseChange}
					isDesktop={isDesktop}
				/>
			</EditorFieldSection>
			{LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN && (
				<EditorFieldSection title="مدرسین">
					<DoctorMultiSelect
						value={instructorIds}
						initialDoctors={initialDoctors}
						onChange={setInstructorIds}
					/>
				</EditorFieldSection>
			)}
		</EditorFormShell>
	);
}
